/**
 * ****************************************************************************
 * @description     :   App
 * @created at      :   2022/07/13
 * @created by      :   
 * @package         :   dailyreportsystem
 * @copyright       :   Copyright (c)
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * mport libraries
 */
import React from "react";
import { BrowserRouter as Router} from 'react-router-dom';

/**
 * import child component
 */
import Layout from './shared/layout'

/**
 * Create component App is parent of all components
 * -----------------------------------------
 * @author : create
 * @access : public
 */
const App = () => {
    return (
        <Router>
            <Layout />
        </Router>
    );
}

export default App;
